<template>
  <div id="nav" v-if="this.$store.state.module.base">
    <ul>
      <li v-if="!$store.state.logged" :class="[$route.name === 'Courses' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/courses' }">{{ $t("navigation.courses") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="!$store.state.logged" :class="[$route.name === 'Parcours' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/parcours' }">{{ $t("les_parcours") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="$store.state.showParticipantsTab" :class="[$route.name === 'Inscriptions' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/inscriptions' }">{{ $t("navigation.participants") }}</router-link>
        <hr class="underline_nav" />
      </li>

      <li v-else :class="[$route.name === 'Live' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live' }">{{ $t("navigation.participants") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="!$store.state.logged" :class="[$route.name === 'Live_Passages' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live_passages' }">{{ $t("intermediaires") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li :class="[$route.name === 'Live_Podiums' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live_podiums' }">{{ $t("podiums") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="!$store.state.logged" :class="[$route.name === 'Live_Carte' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live_carte' }">{{ $t("carte_live") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-else :class="[$route.name === 'Live_Carte' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live_carte' }">Carte et passages live</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="!$store.state.logged" :class="[$route.name === 'Live_Webcams' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live_webcams' }">{{ $t("webcams") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="!$store.state.logged" :class="[$route.name === 'Live_Favoris' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live_favoris' }">{{ $t("favoris") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li :class="[$route.name === 'Resultats' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/resultats' }">{{ $t("resultats") }}</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="$store.state.logged" :class="[$route.name === 'CarteLocalisationUrgence' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/live_carte_urgence' }">Localisation d'urgence</router-link>
        <hr class="underline_nav" />
      </li>
      <li v-if="$store.state.logged" :class="[$route.name === 'PCCourse' ? 'active' : '']">
        <router-link :to="{ path: '/' + this.$store.state.module.base + '/pc-course' }">Déconnexion PC Course</router-link>
        <hr class="underline_nav" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="sass" scoped>
</style>